export default __webpack_public_path__ + "static/ThinkstockPhotos-481381806_article-7019c1d7a56b04471956f08a6d645c87.jpg";